export default __webpack_public_path__ + "static/media/tim_cook.f5dbb401.jpg";